import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import IconSpotHero from '@spothero/icons/spothero';
import {Box, Link, Icon} from '@spothero/ui';

import Config from 'hooks/config';
import {selectAllFilteredFacilities} from 'pages/facilities/store/facilities-selectors';

import MobileFacilitySelectionMenu from './components/mobile-facility-select/MobileFacilitySelectionMenu';
import MobileNavigationMenu from './components/mobile-navigation/MobileNavigationMenu';

const mobileNavigationContainerStyleProps = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    backgroundColor: 'white',
    width: 'full',
    height: {base: 20, tablet: 14},
    paddingX: 4,
};

const MobileNavigationMenuContainer = ({
    menuRef,
    navigationRoutes,
    userEmail,
}) => {
    const filteredFacilities = useSelector(selectAllFilteredFacilities);
    const selectedCount = filteredFacilities.length;
    const {siteUrl} = Config;
    const [areFiltersOpen, setAreFiltersOpen] = useState(false);
    const [isNavigationMenuOpen, setIsNavigationMenuOpen] = useState(false);
    const [isFacilitySelectionOpen, setIsFacilitySelectionOpen] =
        useState(false);

    const onFiltersToggle = () => setAreFiltersOpen((prevState) => !prevState);

    const handleNavigationMenuToggle = () => {
        setIsFacilitySelectionOpen(false);
        setIsNavigationMenuOpen(!isNavigationMenuOpen);
        setAreFiltersOpen(false);
    };

    const handleFacilitySelectionMenuToggel = () => {
        setIsNavigationMenuOpen(false);
        setIsFacilitySelectionOpen(!isFacilitySelectionOpen);
        setAreFiltersOpen(false);
    };

    return (
        <Box ref={menuRef} {...mobileNavigationContainerStyleProps}>
            <MobileFacilitySelectionMenu
                areFiltersOpen={areFiltersOpen}
                onFiltersToggle={onFiltersToggle}
                handleFacilitySelectionMenuToggel={
                    handleFacilitySelectionMenuToggel
                }
                isFacilitiesMenuOpen={isFacilitySelectionOpen}
                numberOfSelectedFacilities={selectedCount}
                userEmail={userEmail}
            />
            <Link
                aria-label="SpotHero"
                data-testid="nav-logo"
                href={siteUrl}
                height={12}
                width={20}
                textAlign="center"
            >
                <Icon as={IconSpotHero} color="primary.default" boxSize={12} />
            </Link>
            <MobileNavigationMenu
                handleNavigationMenuToggle={handleNavigationMenuToggle}
                isNavigationMenuOpen={isNavigationMenuOpen}
                navigationRoutes={navigationRoutes}
            />
        </Box>
    );
};

MobileNavigationMenuContainer.propTypes = {
    menuRef: PropTypes.object.isRequired,
    navigationRoutes: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            route: PropTypes.string,
            paths: PropTypes.arrayOf(PropTypes.string),
            children: PropTypes.arrayOf(
                PropTypes.shape({
                    heading: PropTypes.string.isRequired,
                    submenu: PropTypes.arrayOf(
                        PropTypes.shape({
                            label: PropTypes.string.isRequired,
                            route: PropTypes.string.isRequired,
                            paths: PropTypes.arrayOf(PropTypes.string),
                            subtitle: PropTypes.string,
                            isDisabled: PropTypes.bool,
                        })
                    ),
                })
            ),
        })
    ).isRequired,
    userEmail: PropTypes.string,
};

export default MobileNavigationMenuContainer;
